import ServiceDetail from '@/components/feature/ServiceDetail';

export default function AiAutomationPage() {
  return <ServiceDetail slug="ai-automation" />;
}